'use client';
import {
    dispatchCustomEvent,
    EVENTS,
    handlePropPageAnalytics,
    handlePropUserAnalytics,
    handlePropWebSiteAnalytics,
} from '@/helpers/adobe';
import { memo, useEffect } from 'react';

interface pageViewProps {
    pageType: string;
    customPageName?: string;
}

const PageView = memo(({ pageType, customPageName }: pageViewProps) => {
    const sendAnalytics = () => {
        handlePropWebSiteAnalytics();
        handlePropPageAnalytics(pageType, customPageName);
        handlePropUserAnalytics();

        dispatchCustomEvent(EVENTS.CUSTOM_PAGE_VIEW, {
            detail: window.objDataLayer,
        });
    };

    useEffect(() => {
        sendAnalytics();
    }, []);

    return <></>;
});

export default PageView;
